import _debug from 'debug';
import { adalRequest } from './adal/adal_request';

const debug = _debug('app:fetch_data');
export const fetch = (modelName, ownerId, source, pageNumber, impersonate) => {
  debug('Fetch API called impersonate', impersonate);
  debug('Fetch API called modelName', modelName);
  debug('Fetch API called source', source);
  debug('Fetch API called ownerId', ownerId);
  debug('Fetch API called location', location);
  debug('Fetch API called pageNumber', pageNumber);
  return adalRequest({
    modelName,
    ownerId,
    source,
    method: 'post',
    apiName: 'fetch-details',
    impersonate,
    pageNumber
  });
};

export const fetchPolicyInfo = (modelName, personid, source, ownerId) => {
  debug('Fetch API called modelName', modelName);
  debug('Fetch API called source', source);
  debug('Fetch API called personid', personid);
  return adalRequest({
    modelName,
    personid,
    ownerId,
    source,
    method: 'post',
    apiName: 'fetch-details'
  });
};

export const whoAmI = () => {
  debug('whoAmI API called');
  return adalRequest({
    modelName: 'systemuser',
    method: 'post',
    apiName: 'fetch-details',
    source: ''
  });
};

export const getFullName = (id) => {
  debug('getFullName API called');
  return adalRequest({
    url: `systemusers(${id})?$select=fullname`,
    method: 'get'
  });
};

export const executeQuery = (url) => {
  debug('executeQuery API called');
  return adalRequest({
    url,
    method: 'get'
  });
};



// WEBPACK FOOTER //
// ./src/lib/network/webapi/fetch_data.js